// src/components/Toast.jsx
// Single inline toast — renders fixed in bottom-right.
//
// CLAUDE CODE: prepend `import React from "react";` etc, replace
// the `const PPIcons = window.PPIcons; ...` lines with real imports,
// and add `export default X;` at the bottom (replacing `window.X = X`).

import React from "react";
import * as PPIcons from "./_icons";

function Toast({ msg, isErr, visible }) {
  if (!visible || !msg) return null;
  return (
    <div className={`pp-toast${isErr ? " pp-toast--err" : ""}`}>
      {isErr
        ? <PPIcons.IconAlert />
        : <PPIcons.IconCheckCircle />}
      {msg}
    </div>
  );
}
export default Toast;
